import { ProductNameType } from "@repo/api";
import { useTypedTranslation } from "@repo/ui";
import { useCallback } from "react";

const formatDefaultFufiTitle = (title: string): string => {
    return title
        .split("")
        .filter((char) => char !== "/")
        .join("")
        .trimEnd();
};

const formatUlInitialUnitsFufiTitle = (title: string): string => {
    return title.split("/")[0].trimEnd();
};

const formatFufiTitle = (title: string, productName?: ProductNameType | null): string => {
    if (productName === ProductNameType.NnFufiUl) {
        return formatUlInitialUnitsFufiTitle(title);
    }

    return formatDefaultFufiTitle(title);
};

export const useFormatFufiTitle = (): ((title: string, productName?: ProductNameType | null) => string) => {
    const { t } = useTypedTranslation();

    return useCallback(
        (title: string, productName?: ProductNameType | null) => {
            const prefix = t("crossroad.fufiProductPrefix");
            const cleaned = formatFufiTitle(title, productName);
            if (cleaned.startsWith(prefix)) {
                return cleaned;
            }
            return `${prefix} ${cleaned}`;
        },
        [t],
    );
};
